import type { ReactElement } from 'react';

import type { ValueOf } from 'cpool-utils';

export const DATA_TABLE_SIZE = {
    DEFAULT: 'default',
    SM: 'sm',
} as const;

export type DataTableSize = ValueOf<typeof DATA_TABLE_SIZE>;

export const SORT_TYPES = { ASC: 'ASC', DESC: 'DESC', NO_SORTING: 'NO_SORTING' } as const;

export type SortType = keyof typeof SORT_TYPES;

export type Query = {
    key: string;
    type: SortType;
};

export type ReactElementWithPayloadProp<K extends string = string, V = unknown> = ReactElement<{
    payload: Record<K, V>;
}>;

export type SortQuery = {
    sortQuery: Query;
    setSortQuery: React.Dispatch<React.SetStateAction<Query>>;
    sortTableRows: (rows: ReactElementWithPayloadProp[]) => ReactElementWithPayloadProp[];
    setCustomSortFunction: (key: string, fc: CustomSortFunction) => void;
};

export type CustomSortFunction = (rows: ReactElementWithPayloadProp[], type: SortType) => ReactElementWithPayloadProp[];
